<template>
  <div class="auth-bridge-container">
    <div class="content-wrapper">
      <div v-if="loading" class="loading-section">
        <van-loading type="spinner" color="#1989fa" size="40px" />
        <p class="loading-text">正在验证身份，请稍候...</p>
      </div>
      <div v-else-if="error" class="error-section">
        <van-icon name="warning-o" size="48" color="#ee0a24" />
        <p class="error-text">{{ errorMsg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { authBridge } from '../service/getData'
import {setToken, setLoginInfo, setCheckLoginInfo, setAccountInfo, setConfig, getLoginInfo} from '../util/auth'

export default {
  name: 'AuthBridge',
  data () {
    return {
      loading: true,
      error: false,
      errorMsg: ''
    }
  },
  created () {
    this.handleAuth()
  },
  methods: {
    handleAuth () {
      // 从 URL Query 参数中读取 token
      const token = this.$route.query.token
      const account = this.$route.query.account
      const secretKey = this.$route.query.secretKey

      // 如果没有 token 参数，展示错误提示
      if (!token) {
        this.loading = false
        this.error = true
        this.errorMsg = '缺少身份凭证，请从业务系统重新进入'
        return
      }// 调用后端鉴权接口
      authBridge({ account: account, token: token, secretKey: secretKey }).then(res => {
        console.log('智能客服res', res)
        if (res.code === 0) {
          // 保存 token
          setToken(res.data.token)
          // 保存登录信息
          setLoginInfo(res.data)
          console.log('登录信息', res.data)
          console.log('登录信息', getLoginInfo())
          // 保存登录验证信息
          setCheckLoginInfo(res.data)
          // 存储登录企业账号信息
          if (res.data.companyAccount) {
            setAccountInfo(res.data.companyAccount)
          }
          // 跳转到聊天主页
          this.$router.replace('/')
        } else {
          this.loading = false
          this.error = true
          this.errorMsg = res.msg || '身份验证失败，请联系管理员456'
        }
      }).catch(err => {
        this.loading = false
        this.error = true
        this.errorMsg = '身份验证失败，请联系管理员123'
        console.error('Auth bridge error:', err)
      })
    },
    // 获取配置信息
    getConfigInfoFn (account) {
      const { getConfigInfo } = require('../service/getData')
      const params = { account }
      getConfigInfo(params).then(res => {
        if (res.code === 0) {
          // 存储配置信息
          setConfig(res.data)
          // 跳转到聊天主页
          this.$router.replace('/')
        } else {
          this.loading = false
          this.error = true
          this.errorMsg = res.msg || '获取配置信息失败，请联系管理员'
        }
      }).catch(err => {
        this.loading = false
        this.error = true
        this.errorMsg = '获取配置信息失败，请联系管理员'
        console.error('Get config error:', err)
      })
    }
  }
}
</script>

<style scoped>
.auth-bridge-container {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-text {
  margin-top: 16px;
  font-size: 14px;
  color: #666;
}

.error-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.error-text {
  margin-top: 16px;
  font-size: 14px;
  color: #ee0a24;
  text-align: center;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthBridge.vue